export var variants = {sansA:'$_8CSgH',sansB:'$_3bPMH',sansC:'$_2z_Qv'};